
<template>
  <div>
    <!-- 모달 컨텐츠 -->
    <div class="modal__contents">
      <div class="modal__middlebox">
        <div class="modal__row">
          <img
            class="modal__image"
            src="@/assets/images/img-apply.png"
            alt="접수완료이미지"
          >
        </div>
        <div class="modal__row">
          <h2 class="subtitle subtitle--modal">
            의뢰하신 내용이 정상적으로 접수 되었습니다
          </h2>
        </div>
        <div class="modal__row">
          <p class="description description--modal">
            의뢰하신 내용은 입력 하신 메일로 전송 됩니다.<br>신속하게 검토 한 후 메일 또는 유선으로 연락 드리겠습니다. <br>영업시간 기준 최대 3시간 이내 응답 예정입니다.
          </p>
        </div>
        <div class="modal__row">
          <span class="guidetext guidetext--modal">
            영업시간 : 평일 오전 9시30분 ~ 오후 6시
          </span>
        </div>
      </div>
    </div>
    <!-- 모달 푸터(bottom) -->
    <div class="modal__footer">
      <ul class="modal__buttons">
        <li class="modal__buttonitem">
          <button
            class="button"
            @click="success"
          >
            확인
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>

export default{
  name:'Success',
  emits: ['close', 'success'],
  mounted() {
    this.$emit('success')
  },
  methods:{
    success() {
      this.$emit('close')
    }
  },
}
</script>
<style lang="scss" scoped>
.modal{
  $self:&;
  &__middlebox{
    padding-top:30px;
  }
  &__row{
    padding:0;
    &:not(:first-child){
      padding-bottom:15px;
    }
    &:last-child{
      padding-bottom:30px;
    }
  }
  &__image{
    width:100px;
    height:100px;
  }
  &__buttons{
    width:160px;
    margin:0 auto;
    &:after{
      content:'';
      clear:both;
      display:inline;
    }
  }
  &__buttonitem{
    float:left;
    width:160px;
    height:50px;
    &:not(:first-child){
      margin-left:10px;
    }
  }
}
</style>